var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxFreeService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 123.563,
    viewBox: "0 0 250 123.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    transform: "translate(-191.266 -653.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(191.266 734.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M238.179,808.391c1.606-10.984-2.223-17.5-6.778-18.309-4.677-.829-7.833-2.544-9.248-9.976-1.205-6.337-2.821-12.13-7.49-13.628a5.956,5.956,0,0,0-5.617.991c-3.038,2.506-4.254,7.885-4.6,13.868-.35,6.135-2.39,8.271-5.62,9.215a9.989,9.989,0,0,0-6.52,5.7,17.281,17.281,0,0,0,.118,12.137Z",
    transform: "translate(-191.266 -766.174)",
    fill: "#7ece29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M233.16,811.314c-.734-1.95-2.957-3.227-5.68-1.318-1.23.863-2.294,2.115-4.123,1.912-2.386-.264-1.985-6.2-3.622-9.788a3.222,3.222,0,0,0-6.124.422c-1.092,3.635-.807,9.089-3.48,9.127a4.353,4.353,0,0,1-3.287-1.517c-2.61-2.582-5.565-.773-5.619,2.12a13.154,13.154,0,0,0,1.191,5.591h31.016A13.119,13.119,0,0,0,233.16,811.314Z",
    transform: "translate(-194.046 -775.646)",
    fillRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(5.411 5.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M225.365,798.664,219.376,805c.148-2.687.215-5.474.228-8.228l5.593-5.4-.249-.258-5.343,5.157c.006-2.916-.048-5.784-.133-8.448l4.568-5.092-.267-.24-4.317,4.813c-.118-3.518-.288-6.651-.437-9.023l2.151-3.024-.293-.208-1.9,2.664c-.16-2.461-.289-3.97-.294-4.027l-.357.031c.007.077.245,2.863.478,7.084l-4.04-3.888-.249.259,4.316,4.154c.156,2.935.306,6.5.373,10.315l-5.679-5.334-.246.262,5.934,5.572c.05,3.181.042,6.516-.066,9.781l-4.623-4.546-.252.256,4.858,4.778c-.1,2.8-.279,5.531-.559,8.063l.357.039c.175-1.584.31-3.248.412-4.956l6.28-6.641Z",
    transform: "translate(-202.826 -773.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M207.065,810.564l-2.347,3.98c-.611-6.8-1.9-8.986-1.964-9.094l-.306.187c.017.027,1.439,2.448,2,10.052l-5.547-2.151-.13.334,5.705,2.212q.1,1.507.157,3.281l.358-.01c-.045-1.554-.123-2.946-.223-4.195l2.6-4.414Z",
    transform: "translate(-198.773 -782.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M241.616,816.1l-.129-.334-2.079.806c.373-6.739,1.044-7.548,1.077-7.583l-.121-.132-.107-.144c-.089.065-.749.756-1.147,6.858l-2.4-3.957-.307.186,2.668,4.4c-.068,1.166-.128,2.512-.173,4.068l.359.011c.035-1.233.08-2.331.13-3.312Z",
    transform: "translate(-209.283 -783.467)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(215.186 653.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M396.542,653.4,333.9,687.884v6l3.047-1.427v84.5h141.11v-84.5l3.047,1.427v-6Z",
    transform: "translate(-255.023 -653.392)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 66.964,
    height: 18.223,
    transform: "translate(155.805 39.063)",
    fill: "#acb2b9",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M391.977,692.091v81.97H234.827v-81.73l.876-.35,78-31.154,78,31.154Z",
    transform: "translate(-227.352 -655.467)",
    fill: "#abb8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(118.013 20.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M402.906,682.352a.8.8,0,0,1-.8.8H389a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.109a.8.8,0,0,1,.8.8Z",
    transform: "translate(-388.203 -681.556)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M402.906,686.652a.8.8,0,0,1-.8.8H389a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.109a.8.8,0,0,1,.8.8Z",
    transform: "translate(-388.203 -682.757)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M402.906,690.954a.8.8,0,0,1-.8.8H389a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.109a.8.8,0,0,1,.8.8Z",
    transform: "translate(-388.203 -683.958)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M402.906,695.255a.8.8,0,0,1-.8.8H389a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.109a.8.8,0,0,1,.8.8Z",
    transform: "translate(-388.203 -685.159)",
    fill: "#dde4f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198",
    transform: "translate(137.774 20.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M430.325,682.352a.8.8,0,0,1-.8.8H416.42a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.108a.8.8,0,0,1,.8.8Z",
    transform: "translate(-415.622 -681.556)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M430.325,686.652a.8.8,0,0,1-.8.8H416.42a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.108a.8.8,0,0,1,.8.8Z",
    transform: "translate(-415.622 -682.757)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M430.325,690.954a.8.8,0,0,1-.8.8H416.42a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.108a.8.8,0,0,1,.8.8Z",
    transform: "translate(-415.622 -683.958)",
    fill: "#dde4f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M430.325,695.255a.8.8,0,0,1-.8.8H416.42a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h13.108a.8.8,0,0,1,.8.8Z",
    transform: "translate(-415.622 -685.159)",
    fill: "#dde4f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M310.805,653.39l-86.349,34.489v6l3.575-1.428v84.5H393.578v-84.5l3.575,1.428v-6ZM389.08,771.984H231.93v-81.73l.876-.35,78-31.154,78,31.154.276.11Z",
    transform: "translate(-224.456 -653.39)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M234.831,758.085h10.952v-18.7h33.733v28.3h27.611v-28.3H329v19.905h10.8V749.238h18.293v17h10.8V739.381h15v17.942h8.1v38.671H234.831Z",
    transform: "translate(-227.354 -677.407)",
    fill: "#828aa8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 157.15,
    height: 3.95,
    transform: "translate(7.478 40.313)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 1.641,
    height: 13.199,
    transform: "translate(32.897 42.288)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M277.959,733.979H256.028l9.9-3.6h2.135Z",
    transform: "translate(-233.274 -674.893)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 1.64,
    height: 13.199,
    transform: "translate(67.987 42.288)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M326.646,733.979H304.715l9.9-3.6h2.136Z",
    transform: "translate(-246.872 -674.893)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 1.64,
    height: 13.199,
    transform: "translate(103.075 42.288)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M375.332,733.979H353.4l9.9-3.6h2.135Z",
    transform: "translate(-260.47 -674.893)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 1.64,
    height: 13.199,
    transform: "translate(138.164 42.288)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M424.019,733.979H402.088l9.9-3.6h2.134Z",
    transform: "translate(-274.068 -674.893)",
    fill: "#73748d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(13.005 65.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M292.558,745.257v7.914h-6.249v-5H270.593v5h-1.526v-7.914h-1.538v7.914h-.579v-3.288H265.3v-5h-19.6v5h-1.087v3.288h-.58v-7.914H242.5v52.278h1.538v-2.792h23.49v2.792h1.538v-2.792h23.491v2.792H294.1V745.257Zm-28.9,7.914h-6.232v-2.4h6.232Zm-15.753-2.4h6.233v2.4h-6.233Zm0,42.2v-2.393h6.233v2.393Zm9.521,0v-2.393h6.232v2.393Zm10.1,0h-.579v-3.286h-1.086V778.754H245.706v10.937h-1.087v3.286h-.58V774.841h23.49Zm-19.621-22.3h6.233v2.394h-6.233Zm15.753,2.394h-6.232v-2.394h6.232Zm3.868,0h-.579v-3.287h-1.086V758.852H245.706v10.935h-1.087v3.287h-.58V754.937h23.49Zm5.407,19.9v-2.393h6.233v2.393Zm9.522,0v-2.393h6.23v2.393Zm10.1,0h-.58v-3.286H290.75V778.754H270.593v10.937h-.946v3.286h-.581V774.841h23.491Zm-19.621-22.3h6.233v2.394h-6.233Zm15.752,2.394h-6.23v-2.394h6.23Zm3.869,0h-.58v-3.287H290.75V758.852H270.593v10.935h-.946v3.287h-.581V754.937h23.491Z",
    transform: "translate(-242.501 -744.886)",
    fill: "#ced8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M316.614,745.257v52.278h1.538v-2.792h23.49v2.792h1.538v-2.792h23.491v2.792h1.537V745.257h-1.537v7.914h-.581v-3.288H365v-5H345.4v5H343.76v3.288h-.58v-7.914h-1.538v7.914h-1.526v-5H324.4v5h-6.249v-7.914Zm30.435,5.518h6.233v2.4h-6.233Zm15.754,2.4h-6.232v-2.4H362.8Zm-6.232,39.806v-2.393H362.8v2.393Zm-9.522,0v-2.393h6.233v2.393Zm-3.869-18.137h23.491v18.137h-.581v-3.286H365V778.754H344.847v10.937H343.76v3.286h-.58Zm19.623-1.767h-6.232v-2.394H362.8Zm-15.754-2.394h6.233v2.394h-6.233Zm-3.869-15.742h23.491v18.137h-.581v-3.287H365V758.852H344.847v10.935H343.76v3.287h-.58Zm-11.638,38.04v-2.393h6.231v2.393Zm-9.521,0v-2.393h6.232v2.393Zm-3.869-18.137h23.49v18.137h-.58v-3.286h-.946V778.754H319.959v10.937h-1.227v3.286h-.58Zm19.621-1.767h-6.231v-2.394h6.231Zm-15.752-2.394h6.232v2.394h-6.232Zm-3.869-15.742h23.49v18.137h-.58v-3.287h-.946V758.852H319.959v10.935h-1.227v3.287h-.58Z",
    transform: "translate(-263.2 -744.886)",
    fill: "#ced8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M435.589,745.26v7.916h-.577V749.89h-1.092V744.9h-19.6v4.991h-1.642v3.286H412.1V745.26h-1.535v52.278H412.1v-2.783h23.489v2.783h1.534V745.26Zm-10.1,5.53h6.226v2.386h-6.226Zm-9.525,0H422.2v2.386h-6.238Zm6.238,42.2h-6.238v-2.4H422.2Zm9.513,0h-6.226v-2.4h6.226Zm3.875,0h-.577v-3.3h-1.092V778.766H413.768v10.927h-1.091v3.3H412.1V774.855h23.489Zm-19.626-19.913v-2.386H422.2v2.386Zm9.525,0v-2.386h6.226v2.386Zm10.1,0h-.577v-3.286h-1.092V758.863H413.768v10.928h-1.091v3.286H412.1V754.939h23.489Z",
    transform: "translate(-289.44 -744.89)",
    fill: "#ced8ea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M375.387,735.372h-18.1l-8.492,29.4-8.493-29.4H322.2l-8.493,29.4-8.493-29.4h-18.1l-8.492,29.4-8.492-29.4h-18.1l-17.191,59.5H392.578Z",
    transform: "translate(-227.354 -676.287)",
    fill: "ivory",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M344.272,653.4l86.349,34.487H484L399.44,653.4Z",
    transform: "translate(-257.92 -653.392)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 53.379,
    height: 5.998,
    transform: "translate(172.701 34.492)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M234.827,692.331h57.126l50.263-20.115L313.7,660.828Z",
    transform: "translate(-227.352 -655.467)",
    fill: "#919cb8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxFreeService);
export default __webpack_public_path__ + "static/media/tax-free-service.bb86c59875ecfb7ac4ccfbbcae1db2e1.svg";
export { ForwardRef as ReactComponent };